export default __webpack_public_path__ + "static/media/chillrx_carousel_2.png.webp";